import { render, staticRenderFns } from "./TabComponentPhoto.vue?vue&type=template&id=ed18a9c6&scoped=true"
import script from "./TabComponentPhoto.vue?vue&type=script&lang=js"
export * from "./TabComponentPhoto.vue?vue&type=script&lang=js"
import style0 from "./TabComponentPhoto.vue?vue&type=style&index=0&id=ed18a9c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed18a9c6",
  null
  
)

export default component.exports